export const ROUTE_PATH = '/reconciliations-store-bonus/store[eq]=:store_id';

export const FEATURE_NAME = 'reconciliationStoreBonusDetailsPage';

export const POST_URL = '/store-bonus-repayment-details/';
